<template>
  <div class="footer-container">
    <div class="footer-left" :class="{ 'left-padding': isLeftPadding }">
      <img v-show="errorMessage" class="notification-icon" src="@/assets/img/notification.svg" alt="notification" />
      <span>{{ errorMessage }}</span>
    </div>
    <div class="footer-right">
      테이블링 주식회사 / 1899-9195 / cs@mealant.com / 광고 무료 수신거부: 080-880-5000 | <span class="version" @click="openInput">ver.{{ version }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    isLeftPadding: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    version: {
      type: String,
      default: ''
    }
  },
  methods: {
    openInput () {
      const result = prompt('코드를 입력하세요')
      if (result === '025529045') {
        this.$router.replace('/login')
      }
      if (result === '18999195') {
        this.reload()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";

.footer-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  width: 100%;
  height: 3.5vh;

  .footer-left {
    display: flex;
    @include flex-gap(0.5vh, row);
    align-items: center;
    font-size: 18px; // IE11 fallback
    font-size: unquote("min(1.40625vw, 18px)");
    font-weight: 500;
    color: #FCE800;
    .notification-icon {
      width: 1.875vw;
      height: 3vh;
    }
    &.left-padding {
      display: flex;
      justify-content: center;
      // width: calc(calc(100% - 4.6875vw - 31.25vw));
      // padding-left: 9.609375vw;
    }
  }

  .footer-right {
    display: flex;
    align-items: center;
    font-size: 16px; // IE11 fallback
    font-size: unquote("min(1.25vw, 16px)");
    font-weight: 400;
    color: rgba(255, 255, 255, 0.59);
    span {
      padding: 0 0 0 0.3125vw;
    }
  }
}
</style>
